export const contentDict = {
  title: "Review of Diffusion Models and Recent Advancements",                // Display name
  finishDate: new Date("2023-03-31"),     // format is YYYY-MM-DD
  description: 
    `Covers the seminal works on diffusion models and recent 
    adaptations which enable state-of-the-art generative modelling  
    in text-to-image and text-to-3D synthesis, image inpainting and editing.`,
  tags: ["ML", "Diffusion", "Generative Models"],
  authors: ["Philipp Wulff"],
  coverImage: require('./Imgs/DDPM.png'),
  markdownFile: require('./post.md'),
  parentDirName: "diffusion_models",    
  citations: require('./citations.bib'),
  hidden: false,
};

export default contentDict;